import { render, staticRenderFns } from "./PromotionsList.vue?vue&type=template&id=f5899b3c"
import script from "./PromotionsList.vue?vue&type=script&lang=js"
export * from "./PromotionsList.vue?vue&type=script&lang=js"
import style0 from "./PromotionsList.vue?vue&type=style&index=0&id=f5899b3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports